import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';
import { colors } from '../styles';
import { CATEGORY_COLOR_OPTIONS, normalizeCategoryColor } from '../utils/categoryColors';

const CategoryColorPicker = ({
  selectedColor,
  onSelectColor,
  label = 'Color',
  labelSx = {},
  swatchSize = 38,
  swatchInnerSize = 28,
  checkIconSize = 18
}) => {
  const normalizedColor = normalizeCategoryColor(selectedColor);

  return (
    <Box>
      {label && (
        <Typography variant="body1" color="text.secondary" gutterBottom sx={labelSx}>
          {label}
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {CATEGORY_COLOR_OPTIONS.map((option) => {
          const selected = option.value.toLowerCase() === normalizedColor.toLowerCase();

          return (
            <Tooltip title={option.label} key={option.value}>
              <Box
                component="button"
                type="button"
                aria-label={`${option.label} category color`}
                aria-pressed={selected}
                onClick={() => onSelectColor(option.value)}
                sx={{
                  width: swatchSize,
                  height: swatchSize,
                  p: 0,
                  borderRadius: '50%',
                  border: `2px solid ${selected ? colors.secondary : `${colors.primary}20`}`,
                  backgroundColor: 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'border-color 160ms ease, transform 160ms ease',
                  '&:hover': {
                    borderColor: colors.secondary,
                    transform: 'translateY(-1px)'
                  },
                  '&:focus-visible': {
                    outline: `3px solid ${colors.primary}40`,
                    outlineOffset: 2
                  }
                }}
              >
                <Box
                  sx={{
                    width: swatchInnerSize,
                    height: swatchInnerSize,
                    borderRadius: '50%',
                    backgroundColor: option.value,
                    color: colors.white,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  {selected && <CheckIcon sx={{ fontSize: checkIconSize }} />}
                </Box>
              </Box>
            </Tooltip>
          );
        })}
      </Box>
    </Box>
  );
};

export default CategoryColorPicker;
